import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";
import {
  fetchDepositeAmount,
  submitUpdatePost,
} from "../../features/depositeAmount/depositeAmountSlice";
import { isUserAuthorized } from "../../utils/authorize";

const DepositeAmountLayer = () => {
  const dispatch = useDispatch();

  const [constantData, setConstantData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({
    discountPercentage: "",
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const depositeAmount = useSelector((state) => state.depositeAmount?.items);
  const status = useSelector((state) => state.depositeAmount?.status);
  const error = useSelector((state) => state.depositeAmount?.error);
  const role = useSelector((state) => state?.cred?.user?.role);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchDepositeAmount());
    }

    if (depositeAmount?.data?.constantData) {
      setConstantData(depositeAmount.data.constantData);
    }
  }, [dispatch, status, depositeAmount]);

  const handleOpenEditModal = () => {
    const now = Math.floor(Date.now() / 1000);
    const diff = constantData.timer - now;

    const days = Math.floor(diff / (3600 * 24));
    const hours = Math.floor((diff % (3600 * 24)) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    setEditedData({
      discountPercentage: constantData.discountPercentage,
      days,
      hours,
      minutes,
      seconds,
    });
    setIsModalOpen(true);
  };

  const handleUpdateConfirm = async () => {
    if (window.confirm("Are you sure you want to update the discount data?")) {
      const now = Math.floor(Date.now() / 1000);

      const totalSeconds =
        (Number(editedData.days) || 0) * 86400 +
        (Number(editedData.hours) || 0) * 3600 +
        (Number(editedData.minutes) || 0) * 60 +
        (Number(editedData.seconds) || 0);

      const unixTimestamp = now + totalSeconds;

      await dispatch(
        submitUpdatePost({
          updatedData: {
            discountPercentage: editedData.discountPercentage,
            timer: unixTimestamp,
          },
        })
      );

      setIsModalOpen(false);
      toast.success("Constant data updated successfully!");
      window.location.reload();
    }
  };

  if (status === "loading") return <Loader />;
  // if (status === "failed") return <p>Error: {error}</p>;
  if (status === "failed") return <p>{error}</p>;

  return (
    <div className="row gy-4">
      <ToastContainer />

      {constantData && (
        <div className="col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body text-center">
              <h5 className="card-title text-success">💸 Booking Amount</h5>
              <p className="card-text fs-5">
                <strong>{constantData.discountPercentage}%</strong>
              </p>

              {isUserAuthorized(role) && <button
                className="btn btn-sm btn-outline-primary"
                onClick={handleOpenEditModal}
              >
                <i className="ri-edit-line"></i> Edit
              </button>}
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "350px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Booking Data</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Booking Percentage</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editedData.discountPercentage}
                    onChange={(e) =>
                      setEditedData({
                        ...editedData,
                        discountPercentage: e.target.value,
                      })
                    }
                  />
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">Timer (Remaining)</label>
                  <div className="d-flex gap-2 flex-wrap">
                    {[
                      { label: "D", key: "days" },
                      { label: "H", key: "hours" },
                      { label: "M", key: "minutes" },
                      { label: "S", key: "seconds" },
                    ].map(({ label, key }) => (
                      <div key={key} className="input-group" style={{ width: "130px" }}>
                        <input
                          type="number"
                          className="form-control text-end"
                          value={editedData[key]}
                          onChange={(e) =>
                            setEditedData({
                              ...editedData,
                              [key]: +e.target.value,
                            })
                          }
                        />
                        <span className="input-group-text fw-bold">{label}</span>
                      </div>
                    ))}
                  </div>
                </div> */}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleUpdateConfirm}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepositeAmountLayer;